const ReviewSliderBtn = ({ active = false, onClick }) => {
  return (
    <svg
      onClick={onClick}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="15"
        cy="15"
        r="12.5"
        fill="#CB1D8D"
        stroke="white"
        strokeOpacity={active ? 1 : 0.6}
        strokeWidth="5"
      />
    </svg>
  );
};

export default ReviewSliderBtn;
